import { FormHelperText, styled } from '@mui/material';

export const CustomFormHelperText = styled(FormHelperText, {
  shouldForwardProp: (props) => props !== 'focusColor',
})(({theme, focusColor}) => {
  // default when focusColor is empty
  const color = focusColor || theme.palette.secondary.main;

  return {
    // apply color to the root element
    color,

    // also cover the 'contained' variant class that FormHelperText adds
    '&.MuiFormHelperText-contained': {
      color,
    },
  };
});